<template>
  <footer
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
  >
    <div class="container">
      <nav>
        <ul>
          <li>
            <img class="logo-footer" src="https://sites.appbarber.com.br/appbarber2.png">
          </li>          
        </ul>
      </nav>
      <div class="copyright">
        &copy; {{ year }},
        <a href="https:///www.appbarber.com.br" target="_blank" rel="noopener">AppBarber</a>. 
        Um Produto da
        <a href="http://starapp.com.br" target="_blank" rel="noopener">StarApp Sistemas</a>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style>
.logo-footer {
  width: 80px !important;
  height: auto;
}
</style>
